import React, { useEffect, useState } from 'react';
import { getAllPlan } from '../../services/User/api';
import { ReactComponent as TaskIcon } from './task-icon.svg';
import { ReactComponent as ChecklistIcon } from './checklist-icon.svg';
import { ReactComponent as FlowIcon } from './workflow-icon.svg';
import './moduleRenew.min.css';
import { BMSuRlREACT, PrivateAxios } from '../../environment/AxiosInstance';


function LnModuleRenew({ onModuleSelect }) {
  const [displayFalsePlans, setDisplayFalsePlans] = useState([]);
  const [checkedModules, setCheckedModules] = useState({});
const [modulePricing, setModulePricing] = useState({});
const fetchModulePricing = async () => {
  try {
    const res = await PrivateAxios.get(`${BMSuRlREACT}get-price`);
    if (res.data.success) {
      const data = res.data.data;

      // Parse JSON strings
      const task = JSON.parse(data.task_price);
      const sheet = JSON.parse(data.sheet_price);
      const flow = JSON.parse(data.flow_price);

      // Set formatted pricing
      setModulePricing({
        Task: {
          monthly: Number(task.monthly),
          yearly: Number(task.yearly)
        },
        Checklist: {
          monthly: Number(sheet.monthly),
          yearly: Number(sheet.yearly)
        },
        Workflow: {
          monthly: Number(flow.monthly),
          yearly: Number(flow.yearly)
        }
      });
    }
  } catch (error) {
    console.error("Error fetching module pricing:", error);
  }
};

  useEffect(() => {
    fetchPlans();
    fetchModulePricing(); 
  }, []);

  const fetchPlans = async () => {
    try {
      const response = await getAllPlan();
      const filteredPlans = response.data.filter(
        (item) => item.display === false && item.status === 'Active'
      );
      setDisplayFalsePlans(filteredPlans);
    } catch (error) {
      console.error('Error fetching plans:', error.message);
    }
  };

const handleStaticModuleCheck = (moduleName) => {
  setCheckedModules((prev) => {
    const newState = { ...prev };

    if (moduleName === 'Task' || moduleName === 'Checklist') {
      const val = !prev[moduleName];
      newState['Task'] = val;
      newState['Checklist'] = val;

      // Deselect Workflow if Task or Checklist is manually turned off
      if (!val) {
        newState['Workflow'] = false;
      }

    } else if (moduleName === 'Workflow') {
      const val = !prev['Workflow'];
      newState['Workflow'] = val;

      // ✅ Always auto-check Task and Checklist if Workflow is selected
      if (val) {
        newState['Task'] = true;
        newState['Checklist'] = true;
      } else {
        // Optional: uncheck all if Workflow is unchecked
        newState['Task'] = false;
        newState['Checklist'] = false;
      }
    }

    // ✅ Store selected module list with pricing
    const selectedModules = Object.entries(newState)
      .filter(([_, isChecked]) => isChecked)
      .map(([name]) => ({
        name,
        monthly: modulePricing[name].monthly,
        yearly: modulePricing[name].yearly,
      }));

    localStorage.setItem('selectedModules', JSON.stringify(selectedModules));
    if (onModuleSelect) onModuleSelect(selectedModules);

    return newState;
  });
};



  return (
    <div className="module-list-wrap">
      <label className="custom-checkbox module-checkbox-list-item">
        <input
          type="checkbox"
          checked={!!checkedModules['Task']}
          onChange={() => handleStaticModuleCheck('Task')}
        />
        <span className="checkmark"></span>
        <span className="module-icon">
          <TaskIcon width={46} className={checkedModules['Task'] ? 'text-success' : 'text-primary'} />
        </span>
        <span className="module-name">Task</span>
      </label>

      <label className="custom-checkbox module-checkbox-list-item">
        <input
          type="checkbox"
          checked={!!checkedModules['Checklist']}
          onChange={() => handleStaticModuleCheck('Checklist')}
        />
        <span className="checkmark"></span>
        <span className="module-icon">
          <ChecklistIcon width={46} className={checkedModules['Checklist'] ? 'text-success' : 'text-primary'} />
        </span>
        <span className="module-name">Checksheet</span>
      </label>

      <label className="custom-checkbox module-checkbox-list-item">
        <input
          type="checkbox"
          checked={!!checkedModules['Workflow']}
          onChange={() => handleStaticModuleCheck('Workflow')}
        />
        <span className="checkmark"></span>
        <span className="module-icon">
          <FlowIcon width={46} className={checkedModules['Workflow'] ? 'text-success' : 'text-primary'} />
        </span>
        <span className="module-name">Workflow</span>
      </label>
    </div>
  );
}

export default LnModuleRenew;
